const config = {
  appPath: "",
  version: "1.0.0",
  apiPath: "https://ai-title-cycle.feedspark.com/apis/",
  aiFieldsOP: {"product_name": "Title", "product_type": "Product Type", "brand": "Brand", "google_product_category": "Google Product Category"},
};

export default config;